<template>
    <div class="panel__container">
        <transition name="fade" mode="out-in">
            <plans v-if="isPage('plans')" @page="goToPage"></plans>
            <upgrade v-if="isPage('upgrade')" @page="goToPage"></upgrade>
            <update-payment-method v-if="isPage('update-payment-method')" @page="goToPage"></update-payment-method>
        </transition>
    </div>
</template>

<script>
import Plans from './Plans'
import Upgrade from './Upgrade'
import Pages from '../../../mixins/pages'
import UpdatePaymentMethod from './UpdatePaymentMethod'
import currentTenantAware from '../../../mixins/currentTenantAware'

export default {
    mixins: [Pages, currentTenantAware],

    data () {
        return {
            page: 'plans'
        }
    },

    created () {
        this.resetPrices()
    },

    methods: {
        goingToPage () {
            this.resetPrices()
        }
    },

    components: {
        UpdatePaymentMethod,
        Plans,
        Upgrade
    }
}

</script>
